import { render, staticRenderFns } from "./vip-choose-yunnan.vue?vue&type=template&id=97bce36a&scoped=true&"
import script from "./vip-choose-yunnan.vue?vue&type=script&lang=js&"
export * from "./vip-choose-yunnan.vue?vue&type=script&lang=js&"
import style0 from "./vip-choose-yunnan.vue?vue&type=style&index=0&id=97bce36a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bce36a",
  null
  
)

export default component.exports